module.exports = __webpack_public_path__ + "img/business-icon-04.5d053df7.png";